// extracted by mini-css-extract-plugin
module.exports = {"img_preview":"HomePage_img_preview__2mvwU","upload_button":"HomePage_upload_button__3639O"};